import { FailureNotificationConstants } from './failureNotifications';
import { SuccessNotificationConstants } from './successNotifications';

export const Notifications = {
  ...SuccessNotificationConstants,
  ...FailureNotificationConstants,
};
